module.exports = __webpack_public_path__ + "static/media/bq.28959893.svg";